import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileType } from 'src/service/file-save.service';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { FileUploadFor, LocalService, PageKey, UserGuideType } from '../../../service/local.service';
import { GuideConfigComponent } from '../../popups/guide-config/guide-config.component';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss']
})
export class GuideComponent implements OnInit {
  FileUploadFor = FileUploadFor;
  pageKeys; selectedPageKey: string = "0-0"; lstSectionConfigKeys: string[] = ["guide"]; content = ''; contentLanguageId = '';
  pageKey: PageKey = PageKey.None; type: number = UserGuideType.None;
  isManualDownloadUpload = true; maxBodyHeight = 0; isLoadOnlyContent = false;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private router: Router, private modalService: NgbModal, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.pageKey = routeParams.pageKey;
      this.type = routeParams.type;
      this.configurationManagementService.ensurePageActions(this.pageKey == 0 ? PageKey.Guide : this.pageKey);
      this.content = '';
      this.contentLanguageId = '';
      this.selectedPageKey = [this.type, this.pageKey].join("-");
      if (!this.localService.selected.user) {
        this.onLoad();
      } else {
        this.localService.saveUrl();
        if (this.isLoadOnlyContent) {
          this.isLoadOnlyContent = false;
          this.onLoadGuideContent();
        } else {
          this.onLoad();
        }
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    const currentSelectedPage = this.selectedPageKey;
    this.selectedPageKey = "0-0";
    this.configurationManagementService.getGuideTitlesToDisplay().subscribe(result => {
      this.pageKeys = result;
      this.selectedPageKey = currentSelectedPage == "0-0" ? [this.type, this.pageKey].join("-") : currentSelectedPage;
      this.onLoadGuideContent();
    });
  }

  onLoadGuide() {
    if (this.selectedPageKey && this.selectedPageKey != "0-0") {
      let temp = this.selectedPageKey.split("-");
      this.isLoadOnlyContent = true;
      this.router.navigate(["/guide", temp[0], temp[1]]);
    }
  }

  onLoadGuideContent() {
    if (this.selectedPageKey && this.selectedPageKey != "0-0") {
      let temp = this.selectedPageKey.split("-");
      this.configurationManagementService.getGuideContent(parseInt(temp[0]), parseInt(temp[1])).subscribe(result => {
        this.content = result.value;
        this.contentLanguageId = result.key;
      });
    }
  }

  onAction(index) {
    switch (index) {
      case 1: {
        const modalRef = this.modalService.open(GuideConfigComponent, { size: 'xl' });
        modalRef.componentInstance.selectedPageKey = this.selectedPageKey;
      } break;
      case 2: {
        if (this.isManualDownloadUpload) {
          this.configurationManagementService.downloadGuidesManual().subscribe(result => {
            this.localService.onDownloadFile(result, 'ExtractUserGuides', FileType.BAT);
          });
        } else {
          this.configurationManagementService.getZippedGuides().subscribe(result => {
            this.localService.onDownloadFile(result, 'UserGuides', FileType.ZIP);
          });
        }
      } break;
    }
  }
}
